import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.name";
import React from 'react';
import { StyledColumnCard, StyledColumnCardFlex } from './styles';
export function ColumnCard(props) {
  return /*#__PURE__*/React.createElement(StyledColumnCard, {
    id: props.name,
    className: props.className,
    style: props.style
  }, props.children);
}
export function ColumnCardFlex(props) {
  return /*#__PURE__*/React.createElement(StyledColumnCardFlex, {
    id: props.name,
    className: props.className,
    style: props.style
  }, props.children);
}